import React from 'react';
import moment from 'moment';
import {
    Input,
    Row,
    Col,
    InputNumber,
    Select,
    TreeSelect,
    DatePicker,
    Form,
    Cascader,
    Switch
} from 'antd';
import styles from './youkee.less';

const FormItem = Form.Item;
const InputGroup = Input.Group;
const {RangePicker} = DatePicker;

//高级搜索的表单中的数值类型字段(大于、小于、等于)
export class NumCompare extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            name: props.name,
            label: props.label,
            text: props.text,
            handle: props.handle,
            val: {
                from: '',
                end: '',
            },
        };
        this.onChange = this.onChange.bind(this);
        this.reset = this.reset.bind(this);
    }

    onChange(value, key) {
        let tmp = {
            ...this.state.val,
            [key]: value,
        };
        this.setState({
            val: tmp,
        }, () => {
            this.state.handle(this.state.name, tmp);
        });
    }

    reset() {
        this.setState({val: {from: undefined, end: undefined}});
        this.state.handle(this.state.name, {from: undefined, end: undefined});
    }

    render() {
        const self = this;
        var text = this.state.text;
        return (
            <div>
                <label style={this.state.labelStyle}>{this.state.label}：</label>
                <div>
                    <InputGroup compact style={{display: 'flex'}}>
                        <Input type="number"
                               value={this.state.val.from}
                               onChange={(e) => this.onChange(e.target.value, 'from')}
                               style={{flex: '1 1 auto', textAlign: 'center'}}
                               placeholder="最小值"/>
                        <Input style={{width: 24, borderLeft: 0, pointerEvents: 'none', backgroundColor: '#fff'}}
                               placeholder="~"
                               disabled/>
                        <Input type="number"
                               value={this.state.val.end}
                               onChange={(e) => this.onChange(e.target.value, 'end')}
                               style={{flex: '1 1 auto', textAlign: 'center', borderLeft: 0}}
                               placeholder="最大值"/>
                    </InputGroup>
                </div>
            </div>
        );
    }
}

//高级搜索的表单中的下拉多选字段(用于选项多于3个时)
export class SelectGroup extends React.Component {
    constructor(props) {
        super(props);
        this.oldVal = props.defaultValue ? (props.multiple ? [...props.defaultValue] : props.defaultValue) : null;
        this.state = {
            name: props.name,
            label: props.label,
            multiple: props.multiple || false,
            handle: props.handle,
            allowClear: props.allowClear || false,
            showSearch: props.showSearch || false,
            optionFilterProp: props.showSearch ? 'children' : '',
            val: props.defaultValue ? (props.multiple ? [...props.defaultValue] : props.defaultValue) : [],
            labelStyle: props.labelStyle || {},
        };
        this.changeHandle = this.changeHandle.bind(this);
        this.reset = this.reset.bind(this);
    }

    componentWillReceiveProps(newProps) {
        if (newProps.defaultValue && newProps.defaultValue !== this.oldVal) {
            if (this.state.multiple) {
                //this.oldVal = [...newProps.defaultValue]
                this.setState({val: [...newProps.defaultValue]});
            } else {
                //this.oldVal = newProps.defaultValue
                this.setState({val: newProps.defaultValue});
            }
        }
    }

    changeHandle(value) {
        let dataType = this.props.dataType;
        this.setState({val: value});
        if (dataType === 'number') {
            if ((value instanceof Array) && value.length > 0) {
                this.state.handle(this.state.name, value.map(x => {
                    return isNaN(parseInt(x, 10)) ? null : parseInt(x, 10);
                }));
            } else if ((typeof value === 'string') && value.length > 0) {
                //this.state.handle(this.state.name, parseInt(value, 10));
                this.state.handle(this.state.name, isNaN(parseInt(value, 10)) ? null : parseInt(value, 10));
            } else {
                this.state.handle(this.state.name, null);
            }
        } else {
            this.state.handle(this.state.name, value);
        }
    }

    reset() {
        this.setState({val: []});
        this.state.handle(this.state.name, null);
    }

    render() {
        var {options} = this.props;
        let idVal = 'area' + Math.random();
        if (!(options instanceof Array)) {
            return null;
        }
        return <div>
            <label style={this.state.labelStyle}>{this.state.label}：</label>
            <div id={idVal}>
                <Select
                    showSearch={this.state.showSearch}
                    optionFilterProp={this.state.optionFilterProp}
                    mode={this.state.multiple ? 'multiple' : ''}
                    name={this.state.name}
                    style={{width: '100%'}}
                    defaultValue={this.oldVal}
                    value={this.state.val}
                    placeholder={this.state.text}
                    allowClear={this.state.allowClear}
                    onChange={this.changeHandle}
                    dropdownMatchSelectWidth={false}
                    getPopupContainer={() => document.getElementById(idVal)}
                >
                    {options.map(function (item, key) {
                        return <Select.Option key={key + ''} value={item.value + ''}>{item.text}</Select.Option>;
                    })}
                </Select>
            </div>
        </div>;
    }
}

export class TreeSelectGroup extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            name: props.name,
            label: props.label,
            multiple: props.multiple || false,
            handle: props.handle,
            val: props.defaultValue ? (props.multiple ? [...props.defaultValue] : props.defaultValue) : [],
            labelStyle: props.labelStyle || {},
        };
        this.changeHandle = this.changeHandle.bind(this);
        this.reset = this.reset.bind(this);
    }

    changeHandle(value) {
        let dataType = this.props.dataType;
        this.setState({val: value});
        if (dataType === 'number') {
            if ((value instanceof Array) && value.length > 0) {
                this.state.handle(this.state.name, value.map(x => {
                    return isNaN(parseInt(x, 10)) ? null : parseInt(x, 10);
                }));
            } else if ((typeof value === 'string') && value.length > 0) {
                //this.state.handle(this.state.name, parseInt(value, 10));
                this.state.handle(this.state.name, isNaN(parseInt(value, 10)) ? null : parseInt(value, 10));
            } else {
                this.state.handle(this.state.name, null);
            }
        } else {
            this.state.handle(this.state.name, value);
        }
    }

    reset() {
        this.setState({val: []});
        this.state.handle(this.state.name, null);
    }

    render() {
        const {multiple, name, val, label} = this.state;
        var {options, dropdownStyle, showAll} = this.props;
        let idVal = 'area' + Math.random();
        if (!(options instanceof Array)) {
            return null;
        }
        return <div>
            <label style={this.state.labelStyle}>{this.state.label}：</label>
            <div id={idVal}>
                <TreeSelect
                    size="large"
                    value={val}
                    name={name}
                    multiple={multiple ? true : false}
                    treeCheckable={multiple ? true : false}
                    treeDefaultExpandAll={showAll}
                    style={{width: '100%'}}
                    dropdownStyle={{...dropdownStyle}}
                    showCheckedStrategy={TreeSelect.SHOW_ALL}
                    treeData={options}
                    placeholder={label}
                    onSelect={this.changeHandle}
                    getPopupContainer={() => document.getElementById(idVal)}
                />
            </div>
        </div>;
    }
}

//高级搜索的表单中的文本字段
export class TextInput extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            name: props.name,
            label: props.label,
            text: props.text,
            handle: props.handle,
            disabled: props.disabled,
            //val: ''
            val: props.defaultValue ? props.defaultValue : '',
            labelStyle: props.labelStyle || {},
        };
        this.changeHandle = this.changeHandle.bind(this);
        this.reset = this.reset.bind(this);
    }

    componentWillMount() {
        this.setState({
            val: this.props.defaultValue ? this.props.defaultValue : '',
        });
    }

    changeHandle(e) {
        this.setState({val: e.target.value});
        // this.state.handle(this.state.name, {like: e.target.value});
        this.state.handle(this.state.name, e.target.value);
    }

    reset() {
        this.setState({val: ''});
        this.state.handle(this.state.name, '');
    }

    render() {
        return <div>
            <label style={this.state.labelStyle}>{this.state.label}：</label>
            <Input name={this.state.name} value={this.state.val || this.props.defaultValue}
                   placeholder={this.state.text}
                   onChange={this.changeHandle} style={{width: '100%'}} disabled={this.state.disabled}/>
        </div>;
    }
}

//高级搜索的表单中的开关字段
export class SwitchInput extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            name: props.name,
            label: props.label,
            text: props.text,
            handle: props.handle,
            disabled: props.disabled,
            //val: ''
            val: props.defaultValue ? props.defaultValue : '',
            labelStyle: props.labelStyle || {},
        };
        this.changeHandle = this.changeHandle.bind(this);
        this.reset = this.reset.bind(this);
    }

    componentWillMount() {
        this.setState({
            val: this.props.defaultValue ? this.props.defaultValue : '',
        });
    }

    changeHandle(e) {
        this.setState({val: e});
        this.state.handle(this.state.name, e);
    }

    reset() {
        //this.setState({val: ''});
        //this.state.handle(this.state.name, '');
    }

    render() {
        return <div>
            <label style={this.state.labelStyle}>{this.state.label}：</label>
            <Switch checked={this.state.val || this.props.defaultValue}
                    onChange={this.changeHandle} style={{width: '10px'}} disabled={this.state.disabled}/>
        </div>;
    }
}

//高级搜索的表单中的日期类型字段(之前、之后、当前)
export class DateCompare extends React.Component {
    constructor(props) {
        super(props);
        this.dateFormat = 'YYYY-MM-DD';
        if (props.defaultValue) {
            this.oldVal = {
                from: props.defaultValue.from || '',
                end: props.defaultValue.end || '',
            };
        }
        this.oldVal = props.defaultValue ? (props.multiple ? [...props.defaultValue] : props.defaultValue) : null;
        this.state = {
            name: props.name,
            label: props.label,
            options: props.options,
            handle: props.handle,
            /*optData: {
             from: props.defaultValue && props.defaultValue.from ? moment(props.defaultValue.from, dateFormat) : null,
             end: props.defaultValue && props.defaultValue.end ? moment(props.defaultValue.end, dateFormat) : null,
             },
             val: {
             from: props.defaultValue && props.defaultValue.from ? props.defaultValue.from : '',
             end: props.defaultValue && props.defaultValue.end ? props.defaultValue.end : '',
             },*/
            optData: {
                from: null,
                end: null,
            },
            val: {
                from: '',
                end: '',
            },
            endOpen: false,
            labelStyle: props.labelStyle || {},
        };
        this.fromChange = this.fromChange.bind(this);
        this.endChange = this.endChange.bind(this);
        this.reset = this.reset.bind(this);
        this.onChangeHandle = this.onChangeHandle.bind(this);
    }

    componentWillReceiveProps(newProps) {
        if (newProps.defaultValue && (!this.state.optData.from)) {
            this.setState({
                ...this.state,
                optData: {
                    ...this.state.optData,
                    from: newProps.defaultValue && newProps.defaultValue.from ? moment(newProps.defaultValue.from, this.dateFormat) : null,
                    end: newProps.defaultValue && newProps.defaultValue.end ? moment(newProps.defaultValue.end, this.dateFormat) : null,
                },
                val: {
                    ...this.state.val,
                    from: newProps.defaultValue && newProps.defaultValue.from ? newProps.defaultValue.from : '',
                    end: newProps.defaultValue && newProps.defaultValue.end ? newProps.defaultValue.end : '',
                },
            }, () => {
                this.disabledStartDate(this.state.optData.from);
                this.disabledEndDate(this.state.optData.end);
            });
        }
    }

    fromChange(date, dateString) {
        let dataType = this.props.dataType;
        var optData = this.state.optData;
        optData.from = date;
        optData.end = null;
        var val = this.state.val;
        val.from = dateString || '';
        val.end = '';
        this.setState({optData: optData, val: val});
        if (dataType && dataType === 'date') {
            this.state.handle(this.state.name, optData);
        } else {
            this.state.handle(this.state.name, val);
        }
    }

    endChange(date, dateString) {
        let dataType = this.props.dataType;
        var optData = this.state.optData;
        optData.end = date;
        var val = this.state.val;
        val.end = dateString || '';
        this.setState({optData: optData, val: val});
        if (dataType && dataType === 'date') {
            this.state.handle(this.state.name, optData);
        } else {
            this.state.handle(this.state.name, val);
        }
    }

    onChangeHandle(dates, dateStrings) {
        let dataType = this.props.dataType;
        let val = {
            from: dateStrings[0] || '',
            end: dateStrings[1] || '',
        };
        let optData = {
            from: dates[0] || null,
            end: dates[1] || null,
        };
        this.setState({optData, val});
        if (dataType && dataType === 'date') {
            this.state.handle(this.state.name, optData);
        } else {
            this.state.handle(this.state.name, val);
        }
    }

    reset() {
        var optData = this.state.optData;
        optData.end = null;
        optData.from = null;
        var val = this.state.val;
        val.end = '';
        val.from = '';
        this.setState({optData: optData, val: val});
        this.state.handle(this.state.name, val);
    }

    disabledStartDate = (startValue) => {
        const endValue = this.state.optData.end;
        if (!startValue || !endValue) {
            return false;
        }
        return startValue.valueOf() > endValue.valueOf();
    };

    disabledEndDate = (endValue) => {
        const startValue = this.state.optData.from;
        if (!endValue || !startValue) {
            return false;
        }
        return endValue.valueOf() <= startValue.valueOf();
    };

    handleStartOpenChange = (open) => {
        if (!open) {
            this.setState({endOpen: true});
        }
    };

    handleEndOpenChange = (open) => {
        this.setState({endOpen: open});
    };

    render() {
        const {endOpen, optData, options} = this.state;
        return <div>
            <label style={this.state.labelStyle}>{this.state.label}：</label>
            <RangePicker
                defaultValue={[optData.from, optData.end]}
                onChange={this.onChangeHandle}
                format={this.dateFormat}
            />
            {/*<div style={{ width: '50%', display: 'inline-block' }}>
       <DatePicker disabledDate={this.disabledStartDate}
       onChange={this.fromChange}
       value={optData.from}
       placeholder={options[0].text}
       onOpenChange={this.handleStartOpenChange}
       style={{ width: '100%' }} />
       </div>
       <div style={{ width: '110px', display: 'inline-block' }}>
       <DatePicker disabledDate={this.disabledEndDate}
       onChange={this.endChange}
       value={optData.end}
       placeholder={options[1].text}
       open={endOpen}
       onOpenChange={this.handleEndOpenChange}
       style={{ width: '100%' }} />
       </div>*/}
        </div>;
    }
}

//高级搜索的表单中的单日期类型字段
export class DateItem extends React.Component {
    constructor(props) {
        super(props);
        this.dateFormat = 'YYYY-MM-DD';
        if (props.defaultValue) {
            this.oldVal = {
                from: props.defaultValue.from || '',
                end: props.defaultValue.from || '',
            }
        }
        this.oldVal = props.defaultValue ? (props.multiple ? [...props.defaultValue] : props.defaultValue) : null;
        this.state = {
            name: props.name,
            label: props.label,
            options: props.options,
            handle: props.handle,
            /*optData: {
              from: props.defaultValue && props.defaultValue.from ? moment(props.defaultValue.from, dateFormat) : null,
              end: props.defaultValue && props.defaultValue.end ? moment(props.defaultValue.end, dateFormat) : null,
            },
            val: {
              from: props.defaultValue && props.defaultValue.from ? props.defaultValue.from : '',
              end: props.defaultValue && props.defaultValue.end ? props.defaultValue.end : '',
            },*/
            optData: {
                from: null,
                end: null,
            },
            val: {
                from: '',
                end: '',
            },
            endOpen: false,
        };
        this.fromChange = this.fromChange.bind(this);
        this.endChange = this.endChange.bind(this);
        this.reset = this.reset.bind(this);
    }

    componentWillReceiveProps(newProps) {
        if (newProps.defaultValue && (!this.state.optData.from)) {
            this.setState({
                ...this.state,
                optData: {
                    ...this.state.optData,
                    from: newProps.defaultValue && newProps.defaultValue.from ? moment(newProps.defaultValue.from, this.dateFormat) : null,
                    end: newProps.defaultValue && newProps.defaultValue.end ? moment(newProps.defaultValue.end, this.dateFormat) : null,
                },
                val: {
                    ...this.state.val,
                    from: newProps.defaultValue && newProps.defaultValue.from ? newProps.defaultValue.from : '',
                    end: newProps.defaultValue && newProps.defaultValue.end ? newProps.defaultValue.end : '',
                }
            }, () => {
                this.disabledStartDate(this.state.optData.from);
                this.disabledEndDate(this.state.optData.end);
            });
        }
    }

    fromChange(date, dateString) {
        let dataType = this.props.dataType;
        var optData = this.state.optData;
        optData.from = date;
        optData.end = null;

        var val = this.state.val;
        val.from = dateString || '';
        val.end = '';

        this.setState({optData: optData, val: val});
        if (dataType && dataType === 'date') {
            this.state.handle(this.state.name, optData);
        } else {
            this.state.handle(this.state.name, val);
        }
    }

    endChange(date, dateString) {
        let dataType = this.props.dataType;
        var optData = this.state.optData;
        optData.end = date;

        var val = this.state.val;
        val.end = dateString || '';
        this.setState({optData: optData, val: val});
        if (dataType && dataType === 'date') {
            this.state.handle(this.state.name, optData);
        } else {
            this.state.handle(this.state.name, val);
        }
    }

    reset() {
        var optData = this.state.optData;
        optData.end = null;
        optData.from = null;

        var val = this.state.val;
        val.end = '';
        val.from = '';
        this.setState({optData: optData, val: val});
        this.state.handle(this.state.name, val);
    }

    disabledStartDate = (startValue) => {
        const endValue = this.state.optData.end;
        if (!startValue || !endValue) {
            return false;
        }
        return startValue.valueOf() > endValue.valueOf();
    }

    disabledEndDate = (endValue) => {
        const startValue = this.state.optData.from;
        if (!endValue || !startValue) {
            return false;
        }
        return endValue.valueOf() <= startValue.valueOf();
    }

    handleStartOpenChange = (open) => {
        if (!open) {
            this.setState({endOpen: true});
        }
    }

    handleEndOpenChange = (open) => {
        this.setState({endOpen: open});
    }

    render() {
        const {endOpen, optData, options} = this.state;
        return (
            <div>
                <label className={styles.uk_label}>{this.state.label}：</label>
                <Row>
                    <Col span={10}>
                        <FormItem wrapperCol={{span: 24}} style={{marginBottom: '5px', paddingRight: '5px'}}>
                            <DatePicker disabledDate={this.disabledStartDate}
                                        onChange={this.fromChange}
                                        value={optData.from}
                                // placeholder={options[0].text}
                                        placeholder={this.state.label}
                                        onOpenChange={this.handleStartOpenChange}
                                        style={{width: '100%'}}/>
                        </FormItem>
                    </Col>
                    <Col span={1}>-</Col>
                    <Col span={10}>
                        <FormItem wrapperCol={{span: 24}} style={{marginBottom: '5px', paddingLeft: '5px'}}>
                            <DatePicker disabledDate={this.disabledEndDate}
                                        onChange={this.endChange}
                                        value={optData.end}
                                        placeholder={options[1].text}
                                        open={endOpen}
                                        onOpenChange={this.handleEndOpenChange}
                                        style={{width: '100%'}}/>
                        </FormItem>
                    </Col>
                </Row>
            </div>
        );
    }
}

//高级搜索的表单中的级联选择
export class CascaderOption extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            name: props.name,
            label: props.label,
            handle: props.handle,
            val: props.defaultValue,
            labelStyle: props.labelStyle || {},
        };
        this.changeHandle = this.changeHandle.bind(this);
        this.reset = this.reset.bind(this);
    }

    componentWillReceiveProps(newProps) {
        if (newProps.defaultValue) {
            this.setState({
                val: newProps.defaultValue,
            });
        }
    }

    changeHandle(value) {
        this.setState({val: value});
        this.state.handle(this.state.name, value);
    }

    reset() {
        this.setState({val: []});
        this.state.handle(this.state.name, null);
    }

    render() {
        var {options, disabled} = this.props;
        let idVal = 'area' + Math.random();
        if (!(options instanceof Array)) {
            return null;
        }
        return <div>
            <label style={this.state.labelStyle}>{this.state.label}：</label>
            <div>
                <Cascader value={this.state.val.length == 0 ? this.props.defaultValue : this.state.val}
                          changeOnSelect={true}
                          options={options}
                          disabled={disabled}
                          onChange={this.changeHandle}
                          placeholder={this.state.label}
                          showSearch={{filter: (inputValue, path) => (path.some(option => (option.label).toLowerCase().indexOf(inputValue.toLowerCase()) > -1))}}/>
            </div>
        </div>;
    }
}




// WEBPACK FOOTER //
// ./src/components/corAdvanceFormItemNew.js